import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { actions } from 'src/features/restocking/RestockingState'
import BadgeInput from 'src/features/restocking/components/RestockingWebAppForm/components/BadgeInput/BadgeInput'
import Page from 'src/features/restocking/components/RestockingWebAppForm/components/Page/Page'

const BadgePage: React.FC = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.clearState())
  }, [dispatch])

  return (
    <Page headerTitle='Reposição' goBackRoute='/'>
      <BadgeInput />
    </Page>
  )
}

export default BadgePage
